import { Font } from '@react-pdf/renderer';
import regular from '../../assets/fonts/Roboto-Regular.ttf';
import medium from '../../assets/fonts/Roboto-Medium.ttf';
import bold from '../../assets/fonts/Roboto-Bold.ttf';

Font.register({
    family: "Roboto",
    fonts: [
        { src: regular, fontWeight: 400 },
        { src: medium, fontWeight: 500 }, 
        { src: bold, fontWeight: 700 }
    ],
});